import React, { useEffect, useState } from "react";
import "../css/inputs.css";
import { MONTHS } from "../helpers/constants";

export function PasswordInput({ passInput, setPassInput, placeholder }) {
  const [passVisible, setPassVisible] = useState(false);
  const handleToggleVisibility = () => {
    setPassVisible(!passVisible);
  };

  return (
    <div className="inputWithIcon">
      <input
        type={passVisible ? "text" : "password"}
        id="password"
        className="inputField"
        placeholder={placeholder ? placeholder : "Zadejte heslo"}
        aria-label="Zadejte heslo"
        value={passInput} onInput={e => setPassInput(e.target.value)}
      />
      <button type="button" className="visibility-toggle-button" onClick={handleToggleVisibility}>
        {/* <img
          src={passVisible ? "/img/password_not_visible.png" : "/img/password_visible.png" }
          alt="pass_vis_toggle"
          className="visible-icon"
        /> */}
        <img
          src={passVisible ? "/img/svg/password_not_visible.svg" : "/img/svg/password_visible.svg"}
          width="20"
          height="20"
          alt="pass_vis_toggle"
          className="visible-icon"
        />

      </button>
    </div>
  );
}

export function EmailInput({ emailInput, setEmailInput, placeholder }) {

  return (
    <input
      type="email"
      id="email"
      className="inputField"
      placeholder={placeholder ? placeholder : "Zadejte e-mail"}
      aria-label="Zadejte e-mail"
      value={emailInput} onInput={e => setEmailInput(e.target.value)}
    />
  );
}


export function SearchInput({ searchInput, setSearchInput, placeholder }) {

  const inputEmpty = searchInput != ""
  return (
    <div className={inputEmpty ? 'inputWithIcon activeFilter' : 'inputWithIcon'}>
      <input
        type="text"
        id="password"
        className='searchInputField'
        placeholder={placeholder ? placeholder : "Hledat..."}
        aria-label="Zadejte heslo"
        value={searchInput} onInput={e => setSearchInput(e.target.value)}
      />
      <div className="search-icon-container">
        <img
          src={!inputEmpty ? "/img/svg/search.svg" : "/img/svg/search_purple_bg.svg"}
          width="15"
          height="15"
          alt="pass_vis_toggle"
          className="search-icon"
        />
      </div>
    </div>
  );
}





export function ButtonWIcon({ onClick, iconSrc, text = null, style = {}, disabled = false }) {
  return (
    <button className="buttonWIcon" onClick={onClick} style={style} disabled={disabled}>
      {text && <div className="button-text">{text}</div>}
      <img src={iconSrc} alt="talcitko" className="button-icon" />
    </button>
  );
}

export function ButtonWText({ onClick, text = null, style = {} }) {
  return (
    <button className="buttonWIcon" onClick={onClick} style={style}>
      {text && <div className="button-text">{text}</div>}
    </button>
  );
}

export function CloseButton({ onClick, text = null }) {
  return (
    <button className="buttonWIcon closeButton" onClick={onClick}>
      {text && <div className="button-text">{text}</div>}
      <img src={"/img/svg/close_round_white.svg"} alt="talcitko" className="button-icon" />
    </button>
  );
}

export function TableDropDown({ options, selected, setSelected, title }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  function handelSelect(id) {
    if (selected.includes(id)) {
      setSelected(selected.filter((item) => item !== id))
    } else {
      setSelected([...selected, id])
    }
  }

  function handelSelectClass(id) {
    let className = "dropdown-item"
    if (selected.includes(id)) {
      className += " option-selected"
    }
    return className  
  }

  const isEmpty = selected.length == 0
  return (
    <>
      <div className='dropdown' >
        <div className={`dropdown-header ${!isEmpty && "filterActive"}`} onClick={toggleDropdown}>
          <div className="dropdown-title">{isEmpty ? "Neaktivní filtrování" : "Aktivní filtrování"}</div>
          <img
            loading="lazy"
            src="/img/svg/down_arrow_black.svg"
            className="dropdown-arrow"
            style={{ transform: isOpen ? "rotate(180deg)" : "rotate(0deg)" }}
          />
        </div>
        {isOpen && (
          <div className="dropdown-menu">
            {
              options.map((option, index) => {
                return (
                  <div key={index} className={handelSelectClass(option.id)} onClick={() => { handelSelect(option.id) }}>
                    {option.label}
                    <img src='/img/svg/checkmark_black.svg' className="checkmark"></img>
                  </div>
                )
              })
            }
          </div>
        )}
      </div>
    </>
  );
}


export function MyDatePicker({ value, setValue }) {

  return (
    <div className="date-picker-container">
      <input
        type="date"
        id="date"
        className="my-date-picker"
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />

    </div>
  );
}

export function MyDateTimePicker({ value, setValue }) {
  return (
    <input
      type="datetime-local"
      id="datetime"
      className="my-date-time-picker"
      value={value ? value : ""}

      onChange={(e) => setValue(e.target.value)}
    />
  )
}

export function TextInput({ value, setValue, placeholder}) {

  return (
    <div className={'inputWithIcon'}>
      <input
        type="text"
        className='searchInputField'
        placeholder={placeholder ? placeholder : "..."}
        aria-label="Vstup"
        value={value ? value : ""} onInput={e => setValue(e.target.value)}
      />
    </div>
  );
}


export function TextArea({ value, setValue, placeholder }) {

  return (
    <div className={'inputWithIcon '}>
      <textarea
        className='my-text-area input-field'
        placeholder={placeholder ? placeholder : "..."}
        aria-label="Vstup" onInput={e => setValue(e.target.value)}
        rows="5"
      >
        {value ? value : ""}
      </textarea>
    </div>
  );
}


export function MultiplePartDateInput({ value, setValue }) {
  const [day, setDay] = useState("");
  const [month, setMonth] = useState(null);
  const [year, setYear] = useState("");

  useEffect(() => {

    const paddedDay = String(day.trim()).padStart(2, '0');
    const paddedMonth = String(month+1).padStart(2, '0');
    const formattedYear = String(year.trim());
    setValue(`${formattedYear}-${paddedMonth}-${paddedDay}`)
  },
  [day, month, year])

  return(
    <div className="multiple-part-date-input">
      <TextInput value={day} setValue={setDay} placeholder="den ve formátu DD" />
      <DropDownForDatePicker options={MONTHS} selected={month} setSelected={setMonth} title="Měsíc" />
      <TextInput value={year} setValue={setYear} placeholder="rok ve formátu YYYY" />
    </div>
  )

}

export function DropDownForDatePicker({ options, selected, setSelected, title }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  function handleSelect(option) {
    setSelected(option);
    toggleDropdown();
  }

  return (
    <>
      <div className="dropdown">
        <div className="dropdown-header" onClick={toggleDropdown}>
          <div className="dropdown-title">{selected !== null ? options[selected].substring(3) : title}</div>
          <img
            loading="lazy"
            src="/img/svg/down_arrow_black.svg"
            className="dropdown-arrow"
            style={{ transform: isOpen ? "rotate(180deg)" : "rotate(0deg)" }}
          />
        </div>
        {isOpen && (
          <div className="dropdown-menu">
            {options.map((option, index) => (
              <div
                key={index}
                className={`dropdown-item ${index === selected ? "selected" : ""}`}
                onClick={() => handleSelect(index)}
              >
                {option}
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}

export function DropDownGeneral({ options, selected, setSelected, title }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  function handleSelect(option) {
    setSelected(option);
    toggleDropdown();
  }

  return (
    <>
      <div className="dropdown">
        <div className="dropdown-header" onClick={toggleDropdown}>
          <div className="dropdown-title">{selected !== null ? options[selected] : title}</div>
          <img
            loading="lazy"
            src="/img/svg/down_arrow_black.svg"
            className="dropdown-arrow"
            style={{ transform: isOpen ? "rotate(180deg)" : "rotate(0deg)" }}
          />
        </div>
        {isOpen && (
          <div className="dropdown-menu">
            {options.map((option, index) => (
              <div
                key={index}
                className={`dropdown-item ${index === selected ? "selected" : ""}`}
                onClick={() => handleSelect(index)}
              >
                {option}
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}